import { render, staticRenderFns } from "./UserAuthorization.vue?vue&type=template&id=7181a09f&scoped=true"
import script from "./UserAuthorization.vue?vue&type=script&lang=js"
export * from "./UserAuthorization.vue?vue&type=script&lang=js"
import style0 from "./UserAuthorization.vue?vue&type=style&index=0&id=7181a09f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7181a09f",
  null
  
)

export default component.exports